import type { FC } from 'react';
import { StackedLinkGroup } from '../StackedLinkGroup';
import { useAboutLinks } from './useAboutLinks';

export const StackedAboutLinks: FC = () => {
    const { data, isLoading } = useAboutLinks();
    if (isLoading || !data) return null;
    return <StackedLinkGroup {...data} />;
};
